import { visserApi } from "./visserApi";
const getAllSmallJobWorkOrderByLocationId = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`Planning/GetAllSmallJobWorkOrders?WorkshopLocationId=${request.workShopLocationId}&PageNumber=${request.pageNumber}&PageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getWorkshopLocation = async () => {
    return await visserApi.get('workshoplocation/GetAll');
};
const getAllWorkOrderWithoutTechnicianByLocationId = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`Planning/GetAllWorkOrderWithoutTechnician?WorkshopLocationId=${request.workShopLocationId}&PageNumber=${request.pageNumber}&PageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getAllTechniciansWithWorkordersbyLocationId = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    return visserApi.get(`Planning/GetAllTechniciansWithWorkorders?WorkshopLocationId=${request.workShopLocationId}&PageNumber=${request.pageNumber}&PageSize=${request.pageSize}${filter}`);
};
const PlanningWorkOrderApi = {
    getAllSmallJobWorkOrderByLocationId,
    getWorkshopLocation,
    getAllWorkOrderWithoutTechnicianByLocationId,
    getAllTechniciansWithWorkordersbyLocationId
};
export default PlanningWorkOrderApi;
